export default {
  navigationBarTitleText: '方案详情'
};
